import { CheckCircleIcon } from "@phosphor-icons/react/CheckCircle";
import { XIcon } from "@phosphor-icons/react/X";
import { Icon } from "../Icons/Icon";

interface BooleanIconProps {
  value: boolean;
}

/**
 * `inline` so the mark obeys whatever alignment it is placed in. Tailwind's
 * preflight makes every `svg` `display: block`, and a block ignores
 * `text-align` — so a Table column asking for `align: "center"` still drew the
 * icon hard against the cell's left edge. Inline, it centres (or right-aligns)
 * with the column instead of needing a flex wrapper at every call site.
 */
export function BooleanIcon({ value }: BooleanIconProps) {
  return value ? (
    <Icon
      icon={CheckCircleIcon}
      size="lg"
      color="text-dark-green"
      weight="fill"
      inline
    />
  ) : (
    <Icon icon={XIcon} size="lg" color="text-red" weight="bold" inline />
  );
}
